import React, { useState, useEffect } from 'react';
import { Grid, Box, Container, Typography, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import './IcaDashboard.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScrollAnimation from 'react-animate-on-scroll';
import LeadService from '../../../core/services/leadsService';
import toast from 'react-hot-toast';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import { useLoadScript } from '@react-google-maps/api';
const libraries = ['places'];
const GOOGLE_API_KEY = 'AIzaSyCkMAzfTYAjsRE0zZoITa3ktRqd00zLksU';
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));
const IcaDashboard = () => {
    const navigate = useNavigate();
    const [icaTodayLead, setIcaTodayLead] = useState([]);
    const [count, setCount] = useState(null);
    const [logOutModal, setLogOutModal] = useState(false);
    const [agentLatLng, setAgentLatLng] = useState(null);
    const [customerLatLng, setCustomerLatLng] = useState(null);
    const [leadLatLng, setLeadLatLng] = useState(null);
    const [previousAgentLatLng, setPreviousAgentLatLng] = useState(null);
    const [previousCustomerLatLng, setPreviousCustomerLatLng] = useState(null);
    const [durationAgent, setDurationAgent] = useState('');
    const [distanceAgent, setDistanceAgent] = useState('');
    const [durationCustomer, setDurationCustomer] = useState('');
    const [distanceCustomer, setDistanceCustomer] = useState('');
    const [distance, setDistance] = useState('');
    const userData = JSON.parse(localStorage.getItem('user'));
    const LoginUserName = `${userData?.user?.name || ''} ${userData?.user?.last_name || ''}`.trim();
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: GOOGLE_API_KEY,
        libraries,
    });
    const GetAllTodayLead = async () => {
        try {
            const res = await LeadService.getICATodayLeads();
            if (res.data.success) {
                const meetings = res.data?.meetings_today;

                if (meetings && meetings.length > 0) {
                    // Use map function to iterate through all meetings and extract lat/lng values
                    const agentLocations = meetings?.map((meeting) => {
                        const agentLatLng = {
                            lat: meeting?.agent?.latitude ? parseFloat(meeting?.agent?.latitude) : null,
                            lng: meeting?.agent?.longitude ? parseFloat(meeting?.agent?.longitude) : null,
                        };

                        // Prepare lat/lng for the meeting location
                        const meetingLatLng = {
                            lat: meeting?.meeting_latitude ? parseFloat(meeting?.meeting_latitude) : null,
                            lng: meeting?.meeting_longitude ? parseFloat(meeting?.meeting_longitude) : null,
                        };

                        // Check if customer lat/lng is valid; if not, set it to meetingLatLng
                        const customerLatLng =
                            meeting?.customer?.latitude && meeting.customer?.longitude
                                ? { lat: parseFloat(meeting?.customer.latitude), lng: parseFloat(meeting?.customer?.longitude) }
                                : meetingLatLng;

                        // Set lat/lng values for agent, customer, and meeting
                        setAgentLatLng(agentLatLng);
                        setCustomerLatLng(customerLatLng);
                        setLeadLatLng(meetingLatLng);

                        // Fetch distance and duration for agent to meeting
                        if (agentLatLng.lat && agentLatLng.lng && meetingLatLng.lat && meetingLatLng.lng) {
                            fetchDistanceAndDuration(agentLatLng, meetingLatLng, 'agent');
                        }

                        // Fetch distance and duration for customer to meeting
                        if (customerLatLng.lat && customerLatLng.lng && meetingLatLng.lat && meetingLatLng.lng) {
                            fetchDistanceAndDuration(customerLatLng, meetingLatLng, 'customer');
                        }

                        return agentLatLng; // Return agent's lat/lng for further use
                    });

                    
                    // Store the meetings data in state
                    setIcaTodayLead(meetings); // Store all relevant meetings
                    setCount(res?.data?.count);
                } else {
                    // toast.error("No meetings available for today.");
                }
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        }
    };

    // Use effect for initial and interval calls
    useEffect(() => {
        if (isLoaded) {
            GetAllTodayLead(); // Initial call
            const interval = setInterval(() => {
                GetAllTodayLead();
            }, 20000); // 20-second interval

            return () => clearInterval(interval); // Cleanup interval on unmount
        }
    }, [isLoaded]);

    const fetchDistanceAndDuration = async (origin, destination, type) => {
        const directionsService = new window.google.maps.DirectionsService();
        const request = {
            origin,
            destination,
            travelMode: 'DRIVING',
        };

        directionsService.route(request, (response, status) => {
            if (status === 'OK') {
                const duration = response.routes[0].legs[0].duration.text;
                const distance = response.routes[0].legs[0].distance.text;

                if (type === 'agent') {
                    setDurationAgent(duration);
                    setDistanceAgent(distance);
                } else if (type === 'customer') {
                    setDurationCustomer(duration);
                    setDistanceCustomer(distance);
                }
            } else {
                console.error('Error fetching directions:', status);
            }
        });
    };

    const handleNavigateIcaTracking = (id) => {
        navigate(`/ica-tracking/${id}`);
    };

    return (
        // <Box sx={{ flexGrow: 1 }}>
        <>
            <Box style={{ marginBottom: '3%' }}>
                <Typography variant="h5" component="h2" className="animated-text">
                    <span style={{ fontWeight: 'bold' }} className="bouncing-text">
                        {LoginUserName}
                    </span>
                    , Today you are having <span style={{ fontWeight: 'bold' }}>{count || 0}</span>
                    {count <= 1 ? ' Meeting' : ' Meetings'}.
                </Typography>
            </Box>
            <Grid container spacing={2}>
                {icaTodayLead?.length === 0 ? (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginTop: '12px' }}>
                            <Typography>
                                <span style={{ fontWeight: 'bold' }}>No meetings available for today.</span>
                            </Typography>
                        </Box>
                    </Grid>
                ) : (
                    <Container>
                        <Card style={{ height: '60px', borderRadius: '10px' }}>
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginTop: '22px' }}>
                                <Box style={{ display: 'flex' }}>
                                    <div>
                                        <LocationOnIcon style={{ color: '#8e8ee7' }} />
                                    </div>
                                    <Typography>
                                        Blue Marker = <span style={{ fontWeight: 'bold' }}>Agent</span>
                                    </Typography>
                                </Box>
                                <Box style={{ display: 'flex' }}>
                                    <div>
                                        <LocationOnIcon style={{ color: '#65aa65' }} />
                                    </div>
                                    <Typography>
                                        Green Marker = <span style={{ fontWeight: 'bold' }}>Property</span>
                                    </Typography>
                                </Box>
                                <Box style={{ display: 'flex' }}>
                                    <div>
                                        <LocationOnIcon style={{ color: 'red' }} />
                                    </div>
                                    <Typography>
                                        Red Marker = <span style={{ fontWeight: 'bold' }}>Customer</span>
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>
                    </Container>
                )}
                {icaTodayLead?.map((item, index) => {
                    const agentLat = item?.agent?.latitude;
                    const agentLng = item?.agent?.longitude;
                    const customerLat = item?.customer?.latitude;
                    const customerLng = item?.customer?.longitude;
                    const meetingLat = item?.meeting_latitude;
                    const meetingLng = item?.meeting_longitude;
                    const propertyLatitude = item?.property_latitude;
                    const propertyLongitude = item?.property_longitude;

                    // Construct the base map URL without hardcoded size
                    let mapUrl = `https://maps.googleapis.com/maps/api/staticmap?zoom=14&maptype=roadmap`;

                    // Add the agent marker if coordinates are present
                    // if (agentLat && agentLng) {
                    //     mapUrl += `&markers=color:blue%7Clabel:A%7C${agentLat},${agentLng}`;
                    // }

                    // Add the customer marker if coordinates are present
                    // if (customerLat && customerLng) {
                    //     mapUrl += `&markers=color:red%7Clabel:C%7C${customerLat},${customerLng}`;
                    // }

                    // Add the meeting marker if coordinates are present
                    if (propertyLatitude && propertyLongitude) {
                        mapUrl += `&markers=color:green%7Clabel:P%7C${propertyLatitude},${propertyLongitude}`;
                    } else if (meetingLat && meetingLng) {
                        mapUrl += `&markers=color:green%7Clabel:P%7C${meetingLat},${meetingLng}`;
                    } else if (customerLat && customerLng) {
                        mapUrl += `&markers=color:red%7Clabel:C%7C${customerLat},${customerLng}`;
                    }

                    // Append the API key
                    mapUrl += `&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`;

                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            {/* <ScrollAnimation animateIn="fadeIn"> */}
                                <Item style={{ borderRadius: '20px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                    <div
                                        style={{
                                            marginTop: '2px',
                                            position: 'relative',
                                            border: '1px solid #ddd',
                                            padding: '1px',
                                            borderRadius: '20px',
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                position: 'absolute',
                                                top: '10px',
                                                right: '10px',
                                                cursor: 'pointer',
                                                zIndex: 1,
                                                background: '#fff',
                                                padding: '5px 8px',
                                                borderRadius: '8px'
                                            }}
                                            sx={{
                                                '&:hover': {
                                                    color: '#5c7dbd',
                                                },
                                                color: 'black',
                                            }}
                                            onClick={() => handleNavigateIcaTracking(item?.lead_id)}
                                        >
                                            View Tracking
                                        </Typography>

                                        {/* Google Static Map Image */}
                                        <div style={{ overflow: 'hidden', borderRadius: '15px', position: 'relative' }}>
                                            <img
                                                src={`${mapUrl}&size=500x300`} // Initial size in the URL, updated dynamically by CSS
                                                alt="Static map"
                                                style={{ width: '100%', height: 'auto', borderRadius: '15px' }} // Responsive styles
                                            />
                                        </div>

                                        {/* Information Section */}
                                        <Grid spacing={1} container sx={{padding: '10px'}}>
                                                <Grid item xs={3} md={5}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold', textAlign: 'left', display: 'block', color: '#000' }} className="text-hover-animation">
                                                        Agent Name:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={9} md={7}>
                                                    <Typography variant="body2" className="text-hover-rotate" sx={{display: 'block', textAlign: 'left', color: '#000'}}>
                                                        {item?.agent?.name} {item?.agent?.last_name}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={3} md={5}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold', textAlign: 'left', display: 'block', color: '#000' }} className="text-hover-animation">
                                                        Customer Name:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={9} md={7}>
                                                    <Typography variant="body2" className="text-hover-rotate" sx={{display: 'block', textAlign: 'left', color: '#000'}}>
                                                        {item?.customer?.name} {item?.customer?.last_name}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={3} md={5}>
                                                    <Typography variant="body2" style={{ fontWeight: 'bold',  textAlign: 'left', display: 'block', color: '#000' }} className="text-hover-animation">
                                                        Meeting Location:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={9} md={7}>
                                                    <Typography
                                                    style={{
                                                        wordBreak: 'break-word', 
                                                        overflow: 'hidden', 
                                                        whiteSpace: 'normal', 
                                                        lineHeight: '1.5',
                                                        textAlign:'left',
                                                        paddingRight:'6px',
                                                         color: '#000'
                                                    }}
                                                    variant="body2">{item?.meeting_location || 'N/A'}</Typography>
                                                </Grid>
                                                <Grid item xs={3} md={5}>
                                                    <Typography
                                                        variant="body2"
                                                        style={{
                                                            fontWeight: 'bold',
                                                             textAlign: 'left', display: 'block',
                                                              color: '#000'
                                                        }}
                                                        className="text-hover-animation"
                                                    >
                                                        Property Location:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={9} md={7}>
                                                    <Typography
                                                        variant="body2"
                                                        style={{
                                                            wordBreak: 'break-word', 
                                                            overflow: 'hidden', 
                                                            whiteSpace: 'normal', 
                                                            lineHeight: '1.5',
                                                            textAlign:'left',
                                                            paddingRight:'6px',
                                                             color: '#000'
                                                        }}
                                                    >
                                                        {item?.property_location || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                    </div>
                                </Item>
                            {/* </ScrollAnimation> */}
                        </Grid>
                    );
                })}
            </Grid>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </>

        // </Box>
    );
};

export default IcaDashboard;
